<template>
  <div class="container">
    <div class="regular-delivery__title">
      Магазины
    </div>
    <div class="regular-delivery__content">
      <div class="regular-delivery__actions">
        <q-btn
          outline
          @click="toggleGroupByRegion"
        >
          {{ buttonText }}
        </q-btn>
      </div>
      <Table
        table-id="regularDeliveryTable"
        :table-config="tableConfig"
        :table-data="stores"
        :current-page="page"
        :pages="computedPages"
        :group-by="groupBy"
        @row-click="rowClickHandler"
        @request="onRequestData"
      />
    </div>
  </div>
</template>

<script>
/**
 * Корновой Vue компонент страницы регулярной доставки
 * отображает список магазинов, с возможностью группировки по регионам
 * @module PageRegularDelivery/App
 * @requires Shared/Table
 * @requires PageRegularDelivery/store/store
 * @requires vuex
 * @vue-data {Number} elementsPerPage - количество строк в таблице
 * @vue-data {Array} tableConfig - конфиг таблицы
 * @vue-computed {String} buttonText - текст кнопки группировки
 * @vue-computed {Number} computedPages - итоговое количество страниц для отображения
 * */

import Table from 'Shared/Table'
import store from 'PageRegularDelivery/store/store'
import { mapState, mapActions } from 'vuex'
import tableConfig from 'PageRegularDelivery/tableConfig'

export default {
  name: 'PageRegularDelivery',
  components: {
    Table
  },
  data() {
    return {
      tableConfig
    }
  },
  computed: {
    ...mapState(['stores', 'page', 'totalAmount', 'groupBy', 'elementsPerPage']),
    buttonText() {
      return this.groupBy === 'region' ? 'Снять группировку' : 'Сгруппировать по региону'
    },
    computedPages() {
      return Math.ceil(+this.totalAmount / this.elementsPerPage)
    }
  },
  created() {
    this.getStores()
  },
  methods: {
    ...mapActions(['getStores', 'toggleGroupByRegion']),
    /**
     * Обработчик запроса на обновление данных
     */
    onRequestData(params) {
      this.getStores(params)
    },
    /**
     * Обработчик клика по строке
     */
    rowClickHandler(row) {
      this.$router.push(`/shop/${row.id}`)
    }
  },
  store
}
</script>

<style lang="scss" scoped>
.regular-delivery {
  &__title {
    font-size: 30px;
    font-weight: 500;

    margin-bottom: 24px;
  }

  &__actions {
    margin-bottom: 20px;
  }
}
</style>
